import Reveal from "@/components/common/Reveal";
import { Link } from "react-router-dom";
import { VALUES } from "@/data/content";

export default function About() {
  return (
    <>
      {/* HERO */}
      <section className="relative pt-20 md:pt-24 pb-6 md:pb-10 max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14" data-testid="about-hero">
        <div className="mono-label text-zinc-500">About Mohr Engineering</div>
        <h1 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.02em] font-light mt-3 max-w-4xl">
          Engineered in Abuja.<br /><em className="not-italic text-[#BE1E2D] font-normal">Trusted</em> across Nigeria.
        </h1>
      </section>

      {/* IMAGE */}
      <section className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14 mb-16 md:mb-20">
        <div className="img-hover-scale aspect-[21/9] bg-zinc-100">
          <img
            src="/projects/shore-01.jpg"
            alt="Mohr Engineering project"
            className="w-full h-full object-cover"
          />
        </div>
      </section>

      {/* STORY */}
      <section className="py-10 md:py-16 max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14 grid lg:grid-cols-12 gap-8 lg:gap-12">
        <div className="lg:col-span-4">
          <Reveal>
            <div className="mono-label text-zinc-500">The Practice</div>
            <h2 className="font-display text-3xl md:text-4xl mt-4 leading-[1.05] tracking-tight">
              Registered in Nigeria. Trusted in Abuja. Delivering nationwide.
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-7 lg:col-start-6 space-y-4 text-zinc-700 text-base md:text-[17px] leading-relaxed">
          <Reveal delay={0.05}>
            <p>
              Mohr Engineering Limited is a fully compliant engineering and general contracting firm based in Abuja, Nigeria. We are registered with the Corporate Affairs Commission, tax-compliant, and duly registered with PENCOM, ITF, NSITF and the Bureau of Public Procurement.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p>
              Since our founding we have grown from a small structural consultancy into an integrated delivery firm spanning geotechnical investigation, civil design, civil works and long-term asset maintenance. That integration is what allows us to price honestly and deliver on schedule.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p>
              Our clients range from Nigerian federal institutions to the country's most ambitious private developers. What unites them is the expectation that when Mohr signs a contract, the outcome is already halfway delivered.
            </p>
          </Reveal>
        </div>
      </section>

      {/* MISSION / VISION */}
      <section className="bg-[#0A0A0A] text-white py-16 md:py-24">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14 grid md:grid-cols-2 gap-10 md:gap-14">
          <Reveal>
            <div className="mono-label text-zinc-500">Mission</div>
            <h3 className="font-display text-3xl md:text-4xl mt-4 leading-[1.05] tracking-tight">
              To exceed the expectations of every client — through customer service, flexibility and value at minimum cost.
            </h3>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mono-label text-zinc-500">Vision</div>
            <h3 className="font-display text-3xl md:text-4xl mt-4 leading-[1.05] tracking-tight">
              To optimise environmental functionality and improve efficiency — contributing our quota to Nigeria's development.
            </h3>
          </Reveal>
        </div>
      </section>

      {/* VALUES */}
      <section className="py-16 md:py-20 max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14">
        <Reveal>
          <div className="mono-label text-zinc-500">Our Values</div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl mt-4 leading-[1.05] tracking-tight max-w-2xl">
            Four non-negotiables.
          </h2>
        </Reveal>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-zinc-200 mt-10">
          {VALUES.map((v, i) => (
            <Reveal key={v.k} delay={i * 0.06}>
              <div className="bg-white p-6 md:p-8 h-full min-h-[220px]">
                <div className="mono-label text-[#BE1E2D]">0{i + 1}</div>
                <div className="font-display text-2xl mt-4">{v.k}</div>
                <p className="text-zinc-600 mt-3 leading-relaxed text-[15px]">{v.v}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 md:py-20 bg-[#F9F9F8] border-t border-zinc-200 text-center">
        <div className="max-w-2xl mx-auto px-6">
          <Reveal>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight">
              Bring us a brief.
            </h2>
            <p className="text-zinc-600 mt-4 max-w-md mx-auto">
              We respond to every enquiry within one working day.
            </p>
            <Link to="/contact" className="btn-primary mt-8 inline-flex" data-testid="about-cta-contact">
              Start a Conversation
            </Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
